export default {
	props: {
		validationToolipVisible: {
			type: Boolean,
			default: false
		},
		validationTooltipState: {
			type: String,
			default: 'negative'
		},
		validationMessage: {
			type: String
		}
	}
};
